import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import { useTranslation } from 'react-i18next';

import useGiftOrder from './hooks/useGiftOrder';

interface Props {
    type: string;
    giftItem: GiftItemRow;
    qty: number;
    giftCardImageId?: string;
}

function Footer({ giftItem, qty, giftCardImageId }:Props) {
    const { handleOrder, enabled, state } = useGiftOrder(giftItem, qty, giftCardImageId);
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();
    return (
        <Column
            spacing={14}
            fullWidth
            as='footer'>
            <Row fullWidth justify='space-between'>
                <Text size='xl' fontWeight='bold'>{t('giftOrder.paymentAmount')}</Text>
                <Text size='xl' fontWeight='bold' color={colors.red}>
                    {(giftItem.salePrice * qty * state.giftRecipients.length).toLocaleString()}{priceUnit}
                </Text>
            </Row>
            <Button fullWidth type='button'
                disabled={!enabled}
                onClick={handleOrder}>
                {t('giftOrder.sendGift')}
            </Button>
        </Column>
    );
}

export default Footer;
